import { useCallback } from 'react';

export function useUrlParams() {
  const removeUrlParams = useCallback((paramsToRemove) => {
    const searchParams = new URLSearchParams(window.location.search);

    paramsToRemove.forEach(param => searchParams.delete(param));

    const searchString = searchParams.toString();
    const newUrl = window.location.pathname + (searchString ? '?' + searchString : '');
    window.history.replaceState({}, null, newUrl);
  }, []);

  const getUrlParam = useCallback((paramName) => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(paramName);
  }, []);

  const getAllUrlParams = useCallback(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const params = {};
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    return params;
  }, []);

  return {
    removeUrlParams,
    getUrlParam,
    getAllUrlParams
  };
}
